export default __webpack_public_path__ + "static/media/1.313a58fb.png";